import { GET_MESSAGES, INCOMING_MESSAGE, IS_SENDING_MESSAGE, CLEAR_ALL, FETCHING_MESSAGES, FETCHING_PROJECT_MESSAGES, FETCHED_MESSAGES, FETCHED_PROJECT_MESSAGES, UPDATE_MESSAGE } from "../actions/constants";
import defaults from "./defaults";

const messagesReducer = (state = defaults.messages, { type, payload }) => {
  switch (type) {
    case GET_MESSAGES:
      if (!payload.project_id) return { ...state, list: payload.list, fetched: true, fetching: false, last_fetched: new Date() };
      else return { ...state, [payload.project_id]: payload.list, project_fetched: { ...state.project_fetched, [payload.project_id]: new Date() }, project_fetching: false };
    case INCOMING_MESSAGE:
      if (!payload.project_id) return { ...state, list: [payload.message, ...state.list] };
      else return { ...state, [payload.project_id]: [payload.message, ...(state[payload.project_id] || [])] };
    case UPDATE_MESSAGE:
      if (!payload.project_id) {
        return {
          ...state,
          list: [
            ...state.list.filter((m) => !payload.list.some((p) => m.id === p.id)),
            ...payload.list
          ]
        };
      } else {
        return {
          ...state,
          [payload.project_id]: [
            ...(state[payload.project_id] || []).filter((m) => !payload.list.some((p) => m.id === p.id)),
            ...payload.list
          ]
        };
      }
    case IS_SENDING_MESSAGE:
      return {...state, is_sending_message: payload };
    case FETCHING_MESSAGES:
      return { ...state, fetching: payload };
    case FETCHING_PROJECT_MESSAGES:
      return { ...state, project_fetching: payload };
    case FETCHED_MESSAGES:
      return { ...state, fetched: payload };
    case FETCHED_PROJECT_MESSAGES:
      return { ...state, project_fetched: { ...state.project_fetched, [payload.project_id]: new Date() } };
    case CLEAR_ALL:
      return defaults.messages;
    default:
      return state;
  }
};

export default messagesReducer;